

import React, { useState } from 'react';
import * as XLSX from 'xlsx';
import { Formik, Form } from 'formik';
import {
    Box,
    Typography,
    Button,
    Paper,
    IconButton,
    Stack
} from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import VisibilityIcon from '@mui/icons-material/Visibility';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';

const CustomUploadComponent = ({ values, setFieldValue, resetForm }) => {
    const [openModal, setOpenModal] = useState(false);

    const handleExcelParse = (file) => {
        const reader = new FileReader();
        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);
            console.log("Parsed Excel Data:", jsonData);
        };
        reader.readAsArrayBuffer(file);
    };

    const handleFileChange = (e, setFieldValue) => {
        const file = e.target.files[0];
        if (file) {
            const isExcel = file.name.endsWith('.xls') || file.name.endsWith('.xlsx');
            if (!isExcel) {
                alert('Please upload a valid Excel file (.xls or .xlsx)');
                return;
            }
            setFieldValue("file", file);
            handleExcelParse(file);
        }
    };

    const handleDownload = (file) => {
        const url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    const handleSubmit = (values) => {
        console.log("Submitted file:", values.file);
    };

    return (
        <Box sx={{ p: 2 }}>

            {!values?.file ? (
                <Button
                    component="label"
                    variant="outlined"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        py: 4,
                        px: 6,
                        borderRadius: 2,
                        borderStyle: 'dashed',
                        borderColor: 'gray',
                        bgcolor: '#fff',
                        cursor: 'pointer',
                        textTransform: 'none',
                        '&:hover': {
                            borderColor: 'primary.main',
                            bgcolor: '#f0f0f0',
                        },
                    }}
                >
                    <CloudUploadIcon sx={{ fontSize: 80, color: 'var(--main-color)' }} />
                    <Typography variant="h6" mt={1}>
                        Upload Excel File
                    </Typography>
                    <input
                        type="file"
                        hidden
                        accept=".xls,.xlsx"
                        onChange={(e) => handleFileChange(e, setFieldValue)}
                    />
                </Button>
            ) : (
                <Paper elevation={3} sx={{ p: 2, textAlign: 'center', width: 300 }}>
                    <InsertDriveFileIcon sx={{ fontSize: 50, color: 'var(--main-color)' }} />
                    <Typography variant="subtitle1" fontWeight="bold" mt={1} sx={{
                        wordBreak: 'break-word',
                        whiteSpace: 'pre-wrap',
                        maxWidth: '100%',
                    }}>
                        {/* {values.file.name} */}
                        {values?.file?.name?.match(/.{1,50}/g)?.join('\n')}
                    </Typography>
                    {/* <Typography variant="body2" color="text.secondary">
                                    {values.file.type}
                                </Typography> */}

                    <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
                        {/* <IconButton color="primary" onClick={() => setOpenModal(true)}>
                                        <VisibilityIcon />
                                    </IconButton> */}
                        <IconButton color="success" onClick={() => handleDownload(values.file)}>
                            <DownloadIcon />
                        </IconButton>
                        <IconButton
                            color="error"
                            onClick={() => {
                                resetForm();
                                setOpenModal(false);
                            }}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Stack>

                    {/* <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 3, px: 4, background: "var(--main-color)", color: "white" }}
                                >
                                    Save
                                </Button> */}
                </Paper>
            )}

        </Box>
    );
};

export default CustomUploadComponent;
